import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`
  query getTemplates($organizationId: UUID!) {
    templates(organizationId: $organizationId) {
      id
        name
        current_version_id
        updated_ts
        type_id
        type
    }
  }
`;



export function apiGetTemplates(organizationId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: query,
                variables: {organizationId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.templates);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get templates");
                reject(err); // R
            })
    });
}
